import { combineReducers } from "redux";
import manage_report from "../features/admin/manage_report/Slice";
import manage_ambassador_report from "../features/admin/manage_ambassador_report/Slice";
import manage_rejected_trip_report from "../features/admin/manage_rejected_trip_report/Slice";

const ManageReports = combineReducers({
  manage_report: manage_report,
  manage_ambassador_report: manage_ambassador_report,
  manage_rejected_trip_report: manage_rejected_trip_report,
});

export default ManageReports;
